import styled from 'styled-components';
import { FlexiRow } from '../../../../styles/styled';
import Colors from '../../../../styles/colors';

export const EpisodeRow = styled(FlexiRow)`
  padding: 15px 0;
  background: #f5f5f5;
`;

export const EpisodeColumn = styled.div`
  color: black;
  font-size: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  vertical-align: middle;

  ${props => (props.errored ? 'color: red;' : '')}

  .checkbox-wrapper {
    margin: 0 15px;
  }
`;

export const EpisodeRowTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .header-text {
    margin-left: 25px;
  }

  .episode-details {
    margin-left: 15px;
  }
`;

export const CheckboxWrapper = styled.div`
  display: inline-block;
  width: ${props => props.width || 25}px;
`;

export const AnalyticsIcon = styled.i`
  cursor: pointer;
`;

export const RelativeContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const FloatingFlexiWrapper = styled.div`
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : Colors.mainWhite)};
  padding: 10px 0px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
`;

export const EpisodesHeadRow = styled(FlexiRow)`
  border-bottom: 1px solid ${Colors.lightBorder};
  user-select: none;
  padding: 20px 15px 15px;
  margin: 0 20px;

  .items-selected {
    font-size: 12px;
    text-align: left;
    white-space: nowrap;
    position: absolute;
    top: -20px;
  }
`;

export const SoundcastSelectRow = styled(FlexiRow)`
  position: relative;
  padding: 7px 15px;
`;

export const SoundcastSelectColumn = styled.div`
  color: black;
  font-size: 1.8rem;
  line-height: 24px;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  vertical-align: middle;

  .checkbox-wrapper {
    width: 25px;
  }
`;

export const SoundcastDragColumn = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  color: black;
  vertical-align: middle;

  i {
    padding-top: 0.5rem;
    padding-right: 1rem;
    padding-left: 0;
    font-size: 2.5rem;
  }
`;

export const ScrollableContent = styled.div`
  overflow-y: auto;
  min-height: 1px;
  position: relative;
  margin: 5px;
  height: 100%;
`;

export const EmptyEpisodeList = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const ActionButtonWrappers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  button {
    color: #fff;
    border-radius: 5px;
    letter-spacing: 1px;
    padding: 5px 20px;
    cursor: pointer;
    border: 1px solid ${Colors.mainOrange};
    background-color: ${Colors.mainOrange};

    &:disabled {
      pointer-events: none;
      box-shadow: none;
      opacity: 0.65;
    }
  }

  @media (max-width: 991px) {
    flex-direction: column;

    button {
      width: 100%;
    }

    .dropdown-menu {
      width: 100%;
      text-align: center;
    }
  }
`;

export const SoundcastRow = styled.div`
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  margin-left: 0;
  background-color: ${Colors.mainWhite};
`;

export const SoundcastDrag = styled.div`
  text-align: center;
  color: ${Colors.darkGrey};
  width: 4rem;
  padding: 25px 20px;
  padding-left: 1rem;
  i {
    font-size: 3rem;
  }
`;

export const SoundcastInfo = styled.div`
  // height: 96;
  background-color: ${Colors.mainWhite};
  padding-top: 15px;
  padding-bottom: 15px;
  // padding-left: 0;
  padding-right: 0;
`;

export const SoundcastImage = styled.img`
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  // margin-right: 30px;
  // float: left;
`;

export const SoundcastDescription = styled.div`
  // height: 46px;
  // float: left;
  // width: 65%;
  padding-right: 0;

  span {
    font-size: 18px;
    font-weight: bold;
    // display: block;
  }
`;

export const SoundcastUpdated = styled.div`
  font-size: 16px;
`;

export const SoundcastLinksRow = styled.div`
  margin-top: 10px;
`;

export const SoundcastLinks = styled.div`
  font-size: 16px;
  .landing-page-link {
    padding-right: 15px;
    cursor: pointer;
    span {
      color: ${Colors.mainOrange};
    }
  }
  .non-payment-signup-link {
    padding-right: 15px;
    pointer-events: ${props => (props.disableSignup ? 'none' : 'auto')};
    span {
      color: ${props => (props.disableSignup ? '#cccccc' : Colors.link)};
    }
  }
  .youtybe-link {
    padding-right: 15px;
    pointer-events: ${props => (props.youtubeState === 'CONNECTED' ? 'auto' : 'none')};
    span {
      color: ${props => (props.youtubeState === 'CONNECTED' ? Colors.mainOrange : '#cccccc')};
    }
  }
  .checkout-page-link {
    padding-right: 15px;
    span {
      color: ${Colors.mainGreen};
    }
  }
  span {
    cursor: pointer;
  }
`;

export const SoundcastStatus = styled.div`
  font-size: 1.3rem;
  ${props => (props.published ? 'color: #9f9f9f;' : 'color: #F44336;')}
  font-weight: 600;
  text-transform: uppercase;
`;

export const SoundcastSubscribers = styled.div`
  display: block;
  // float: right;
  padding-top: 10px;
  padding-left: 0;
  padding-right: 0;
  font-size: 15px;
  text-align: center;
  z-index: 1;
`;

export const SoundcastActionButton = styled.div`
  border-width: ${props => (props.borderWidth ? props.borderWidth : '1.5px')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '2px')};
  color: ${props => (props.color ? props.color : Colors.link)};
  border-color: ${props => (props.color ? props.color : Colors.link)};
  height: 35px;
  max-width: 150px;
  border-radius: 5px;
  font-size: 16px;
  // letter-spacing: 1.5rem;
  font-weight: bold;
  word-spacing: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
  margin-top: 10px;
  margin-right: 7px;
  margin-left: 7px;
  border-style: solid;
  cursor: pointer;
  // overflow: auto;
`;

export const SoundcastDropdownMenu = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4px;
  cursor: pointer;
  .dropdown {
    .dropdown-toggle {
      text-align: center;
      font-size: 2.3rem;
      justify-content: center;
    }
    ul {
      font-size: 15px;
      min-width: 120px;
      li {
        margin: 10px 16px;
        a {
          padding: 0;
        }
      }
    }
  }
`;
